import { Divider, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useForm,
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FormType } from '@/api/enum/formType.enum';
import {
	Dispatch,
	forwardRef,
	SetStateAction,
	useEffect,
	useImperativeHandle,
} from 'react';
import AppDatePicker from '@/common/components/form-inputs/AppDatePicker';
import dayjs from 'dayjs';
import { API_DATE_FORMAT, notFutureDate } from '@/utils/dateHelper';
import AppTextField from '@/common/components/form-inputs/AppTextField';

interface Props {
	type: FormType;
	details?: any;
	setType: Dispatch<SetStateAction<FormType>>;
}

const EditAppendix6Form = forwardRef(
	({ type, setType, details }: Props, ref) => {
		const { t } = useTranslation();
		const defaultValues: DefaultValues<any> = {};

		useEffect(() => {
			if (details) methods.reset(details);
		}, [details]);

		const formSchema = Yup.object().shape({
			fromOfficerInCharge: Yup.string().required(t('errorMessage.pleaseEnter')),
			fromDate: Yup.string()
				.required(t('errorMessage.pleaseEnter'))
				.test(notFutureDate(t('errorMessage.dateCannotBeFuture'))),
		});
		const methods = useForm<any>({
			defaultValues,
			resolver: yupResolver(formSchema),
			mode: 'onChange',
			shouldFocusError: true,
		});

		useImperativeHandle(ref, () => ({
			getFormData: () => methods.getValues(),
			validateForm: () => {
				methods.trigger();
				methods.formState.isValid;
				return methods.trigger().then(() => methods.formState.isValid);
			},
		}));

		return (
			<>
				<FormProvider {...methods}>
					<Typography variant='h6' sx={{ fontWeight: 'bold' }} marginBottom={2}>
						{t('preAdmission.from')}
					</Typography>
					<form onSubmit={methods.handleSubmit((e: any) => e.preventDefault())}>
						<Grid container spacing={3} marginTop={0} marginBottom={3}>
							<Grid size={6}>
								<AppTextField
									control={methods.control}
									name='fromOfficerInCharge'
									label={t('preAdmission.officerInCharge') + '*'}
								/>
							</Grid>
							<Grid size={6}>
								<AppTextField
									control={methods.control}
									name='fromRefNo'
									label={t('preAdmission.ref')}
								/>
							</Grid>
							<Grid size={6}>
								<AppDatePicker
									control={methods.control}
									name='fromDate'
									label={t('preAdmission.date') + '*'}
									maximumDate={dayjs().startOf('day').format(API_DATE_FORMAT)}
								/>
							</Grid>
						</Grid>
						<Divider sx={{ marginBottom: '16px' }} />
					</form>
				</FormProvider>
			</>
		);
	}
);

EditAppendix6Form.displayName = 'EditAppendix6Form';

export default EditAppendix6Form;
